import * as api from '../../../clients/einlasskontrolle';

import {Action} from '@ngrx/store';

export const GET_PROTOKOLL_LISTE = '[EinlasskontrolleModul] GetProtokollListe laden';
export const GET_PROTOKOLL_LISTE_AUSFUEHREN = '[EinlasskontrolleModul] GetProtokollListe ausführen';
export const GET_PROTOKOLL_LISTE_ERFOLGREICH = '[EinlasskontrolleModul] GetProtokollListe laden erfolgreich';
export const GET_PROTOKOLL_LISTE_FEHLER = '[EinlasskontrolleModul] GetProtokollListe Ladefehler';
export const GET_PROTOKOLL_LISTE_NICHT_AUSGEFUEHRT = '[EinlasskontrolleModul] GetProtokollListe nicht ausgeführt (evtl. Offline)';


export class GetProtokollListeAction implements Action {
    readonly type = GET_PROTOKOLL_LISTE;
        constructor(public optPayload: any = null) {}
    }
export class GetProtokollListeAusfuehrenAction implements Action {
    readonly type = GET_PROTOKOLL_LISTE_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetProtokollListeErfolgreichAction implements Action {
    readonly type = GET_PROTOKOLL_LISTE_ERFOLGREICH;
        constructor(public payload: Array<api.ProtokollEntity>, public optPayload: any = null) {}
    }
export class GetProtokollListeFehlerAction implements Action {
    readonly type = GET_PROTOKOLL_LISTE_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetProtokollListeNichtAusgefuehrtAction implements Action {
    readonly type = GET_PROTOKOLL_LISTE_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type EinlasskontrolleQueryProtokollListeActions =
    GetProtokollListeAction
    | GetProtokollListeAusfuehrenAction
    | GetProtokollListeErfolgreichAction
    | GetProtokollListeFehlerAction
    | GetProtokollListeNichtAusgefuehrtAction
    ;
